import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UpdatePrivacySettingsInput } from '@teentack/shared';
import { fetchPrivacySettings, savePrivacySettings } from './privacy.api';

export const privacyKeys = {
  settings: ['privacy', 'settings'] as const,
};

export function usePrivacySettings(enabled = true) {
  return useQuery({
    queryKey: privacyKeys.settings,
    queryFn: fetchPrivacySettings,
    enabled,
    staleTime: 60_000,
  });
}

export function useSavePrivacySettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdatePrivacySettingsInput) => savePrivacySettings(input),
    onSuccess: (saved) => {
      queryClient.setQueryData(privacyKeys.settings, saved);
      // Message visibility changes what the threads themselves return, and
      // hiding a location changes what a connected parent sees — both caches
      // are now wrong rather than merely stale.
      void queryClient.invalidateQueries({ queryKey: ['conversations'] });
      void queryClient.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}
